const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_shariti-academy/artifacts/uwuprdgh_SHARITI%20LOGO%20OFFICIEL.png";

/**
 * Shariti official logo with optional ACADEMY wordmark below.
 *
 * Variants:
 *  - "full"     : entire artwork (icon + SHARITI + tagline) — for hero / login / loading
 *  - "compact"  : same image, sized smaller — for sidebar / nav
 *  - "stamp"    : square mark only (icon clipped) — for avatar-like spots
 *
 * Props:
 *  - showAcademy  : renders thin orange outlined "ACADEMY" wordmark below the logo
 *  - academySize  : "sm" | "md" | "lg" — controls academy text size
 */
const ACADEMY_SIZES = {
    sm: "text-[10px] tracking-[0.45em]",
    md: "text-xs tracking-[0.5em]",
    lg: "text-sm sm:text-base tracking-[0.55em]",
};

function AcademyWordmark({ size = "md", className = "" }) {
    return (
        <p
            data-testid="academy-wordmark"
            className={`uppercase select-none ${ACADEMY_SIZES[size]} ${className}`}
            style={{
                fontWeight: 200,
                color: "transparent",
                WebkitTextStroke: "1px #F89F63",
                textShadow: "0 0 24px rgba(238,114,46,0.18)",
            }}
        >
            Academy
        </p>
    );
}

export default function Logo({
    variant = "compact",
    className = "",
    showAcademy = false,
    academySize = "md",
    wrapperClassName = "",
}) {
    if (variant === "stamp") {
        return (
            <span
                className={`inline-block rounded-2xl overflow-hidden ${className}`}
                style={{
                    backgroundImage: `url(${LOGO_URL})`,
                    backgroundSize: "115% 130%",
                    backgroundPosition: "center 28%",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: "#181818",
                }}
                aria-label="Shariti"
                role="img"
                data-testid="shariti-logo-stamp"
            />
        );
    }
    const img = (
        <img
            src={LOGO_URL}
            alt="Shariti"
            className={`object-contain ${className}`}
            data-testid={`shariti-logo-${variant}`}
        />
    );
    if (!showAcademy) return img;
    return (
        <div className={`flex flex-col items-center ${wrapperClassName}`}>
            {img}
            <AcademyWordmark size={academySize} className="mt-1" />
        </div>
    );
}

export { AcademyWordmark };
